import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContainerContent = styled.div`
  display: flex;
  flex-direction: column;

  padding: ${({ theme }) => theme.spacing[4]}px
    ${({ theme }) => theme.spacing[6]}px;

  gap: ${({ theme }) => theme.spacing[5]}px;
`;

export const ProdutoInfoTextos = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[2]}px;
`;

export const ProdutoTags = styled.div`
  display: flex;
`;

export const ContainerProdutoInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[4]}px;
`;

export const ContainerAcoesProdutos = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[5]}px;
`;

export const ContainerAccordion = styled.div`
  display: flex;
`;

export const ContainerQuantidade = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const ContainerEscolhaValor = styled.div`
  display: flex;
  flex-direction: column;

  gap: ${({ theme }) => theme.spacing[4]}px;
`;

export const BotaoEscolhaPlano = styled.button`
  background: none;
  outline: none;
`;

export const ContainerPrecoPlano = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 88px;
  gap: ${({ theme }) => theme.spacing[2]}px;
`;

export const ContainerCarrinho = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;

  padding: ${({ theme }) => theme.spacing[4]}px;
  gap: ${({ theme }) => theme.spacing[5]}px;
`;

export const ContainerPrecos = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  gap: ${({ theme }) => theme.spacing[1]}px;
`;

export const ContainerDetalhesAccordion = styled.div`
  display: flex;
  flex-direction: column;
`;
